import {normalize} from '../../util/utils';
import initialState from '../initialstate';
import * as types from '../../actions/actiontypes';

export default function formActionsReducer(state = initialState.formActions, action) {
	let newState;
	switch (action.type) {
		case types.GET_ENGAGEMENT_FORM_ACTIONS: {
			if (action.response && !action.error) {
				newState = {...state};

				// Available actions:
				newState.availableActions = action.response.availableActions;

				// Selected actions:
				newState.selectedActions = normalize(action.response.selectedActions, undefined, undefined);

				// Related risks: cant normalize cuz no id field
				newState.risks = action.response.risks;
				newState.relatedDocuments = action.response.relatedDocuments || [];

				newState.summaryResponses = normalize(action.response.summaryResponses, 'smartEvidenceSourceId');

				// Documents:
				let responseDocuments = [];
				for (const doc of action.response.documents) {
					const document = {
						...doc,
						selectedActions: action.response.selectedActions.filter((a) => a.documentId === doc.id).map((a) => a.id)
					};

					responseDocuments.push(document);
				}

				newState.documents = normalize(responseDocuments, undefined, undefined);

				// Mark as loaded after API data is processed
				newState.isLoaded = true;
			}
			break;
		}
		case types.CLEAN_COMPONENTS_AND_FORMACTIONS: {
			// Renders Group involvement summary table with up-to-date data.
			return {...state, selectedActions: null, availableActions: null, relatedDocuments: [], isLoaded: false};
		}
		default: {
			break;
		}
	}

	return newState || state;
}
